export default __webpack_public_path__ + "static/media/logo-light-mode.728fd4db.svg";